/* ==========================================================================
   Vendor
   ========================================================================== */

import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import Alpine, { Alpine as AlpineType } from 'alpinejs';

declare global {
	interface Window {
		Alpine: AlpineType;
	}
}

window.Alpine = Alpine;

Alpine.plugin(collapse);
Alpine.plugin(focus);

Alpine.start();
